/**
 * @param {string[]} queryParams
 * @returns {Object.<string, ?string|string[]>}
 */
export default function (queryParams) {
    const search = window.location.search;
    const urlParams = new URLSearchParams(search);

    if (!Array.isArray(queryParams)) {
        throw new TypeError("queryParams must be an array");
    }

    return queryParams.reduce((queryMap, queryName) => {
        const values = urlParams.getAll(queryName);

        if (values.length === 0) {
            queryMap[queryName] = null;
        } else if (values.length === 1) {
            queryMap[queryName] = values[0];
        } else {
            queryMap[queryName] = values;
        }

        return queryMap;
    }, {});
}
